<template>
  <div v-if="showPickupInfo" class="margin-bottom-m">
    <template v-if="showPickupInformation">
      <h2 class="h5 margin-bottom-xs">
        {{ pickupInfoText }}
      </h2>
      <div class="cell large-8">
        <p v-if="differentExchangeAddress" class="exchange-address-text margin-bottom-xs">
          {{ exchangeInformationMessage }}
        </p>
      </div>
      <div class="margin-bottom-xs">
        <div v-for="(line, index) in addressLines" :key="index" v-text="line"></div>
        <div v-if="storePageUrl">
          <a class="link-body" :href="storePageUrl" target="_blank">
            {{ viewStoreInfoText }}
          </a>
        </div>
      </div>
    </template>
    <div>
      <div v-if="fullName" class="full-name">{{ fullName }}</div>
      <div v-if="emailAddress">{{ emailAddress }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ORDER_DETAILS } from 'config';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const { pickupInfoText, exchangeInformationMessage, viewStoreInfoText } = ORDER_DETAILS;
const dataInfo = computed(() => props.data || {});
const { differentExchangeAddress, storePageUrl, emailAddress } = dataInfo.value;
const showPickupInfo = computed(() => Object.keys(props.data || {}).length > 0);
const showPickupInformation = computed(() => props.data.shipmentStatusCode !== 109 || props.data.shipmentType !== 'BOPS');
const fullName = computed(() => {
  const { firstName, lastName } = props.data;
  return [firstName, lastName].filter(Boolean).join(' ');
});
/* Computed address lines */
const addressLines = computed(() => {
  const { storeName, addressLine1, addressLine2, city, state, postalCode, phoneNumber } = props.data;
  const cityStateZip = [city, state, postalCode].filter(Boolean).join(' ');
  return [storeName, addressLine1, addressLine2, cityStateZip, phoneNumber].filter(Boolean);
});
</script>
<style lang="scss" scoped>
.exchange-address-text {
  color: $gray-1-color;
  word-break: break-word;
  white-space: break-spaces;
}
</style>
